export const timeSheetDetailsRoutes = [
  {
    path: 'time-sheet-batch-pdf',
    name: 'time-sheet-batch-pdf',
    component: () =>
      import(/* webpackChunkName: "time-sheet-details-pdf" */ './components/TimeSheetBatchPdf.vue'),
    props: true
  },
  {
    path: ':id',
    name: 'time-sheet-details',
    component: () => import(/* webpackChunkName: "time-sheet-details" */ './TimeSheetDetails.vue')
  },
  {
    path: 'pdf/:id',
    name: 'time-sheet-details-pdf',
    component: () =>
      import(/* webpackChunkName: "time-sheet-details-pdf" */ './components/TimeSheetDetailsPdf.vue')
  }
];
